import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import api from '../services/api';

// Reads the company's configured timezone/base currency reactively from Redux —
// updates immediately if Settings changes them, unlike the localStorage-based
// fallback in utils/formatDate.js (used by non-component/non-hook code).
export function useCompanyTimezone() {
  return useSelector((state) => state.auth.user?.timezone) || 'Asia/Kolkata';
}

export function useCompanyCurrency() {
  return useSelector((state) => state.auth.user?.baseCurrency) || 'INR';
}

// Fetches the company's configured exchange rates (Settings → Currency) so
// pages that aggregate values across multiple deal/lead currencies can
// convert each one into the base currency before summing, instead of adding
// raw numbers from different currencies together.
export function useCurrencyRates() {
  const [ratesCtx, setRatesCtx] = useState({ baseCurrency: 'INR', rates: {}, loading: true });

  useEffect(() => {
    api.get('/crm/currency/rates')
      .then(res => setRatesCtx({ baseCurrency: res.data.baseCurrency, rates: res.data.rates, loading: false }))
      .catch(() => setRatesCtx(prev => ({ ...prev, loading: false })));
  }, []);

  return ratesCtx;
}
